/* ============================================================================
   RFQ – Anfragekorb (B2B). Vollständig gekapselt, getrennt vom Shopify-Cart.
   - Speicher: localStorage Key irs_rfq_basket_v2 (überlebt Browser-Neustart; Migration v1->v2).
   - Eintrag: { handle, titel, teilenummer, url, menge }.
   - Übermittlung gekapselt: submitInquiry(payload) -> formspreeAdapter(payload).
   Kein cart.js / cart-drawer.js Touch. Alle Selektoren rfq-* / data-rfq-*.
   ============================================================================ */
(function () {
  'use strict';

  var KEY = 'irs_rfq_basket_v2';
  var OLD_KEY = 'irs_rfq_basket_v1';
  var MAX = 50;

  /* === EINZIGE später zu tauschende Stelle (Backend-Wechsel) ============== */
  var FORMSPREE_RFQ_ENDPOINT = 'https://formspree.io/f/xvzjkoqa';
  /* ======================================================================== */

  /* i18n: Texte kommen aus dem Locale-System (snippets/rfq-floating.liquid,
     <script data-rfq-i18n>). Deutsche Defaults als Fallback, falls das JSON fehlt. */
  var I18N = {
    part_one: 'Teil', part_other: 'Teile', part_no: 'Teile-Nr.',
    qty: 'Menge', qty_decrease: 'Menge verringern', qty_increase: 'Menge erhöhen',
    remove_part: 'Teil entfernen',
    sending: 'Wird gesendet …',
    send_error: 'Senden fehlgeschlagen. Bitte später erneut versuchen oder uns direkt kontaktieren.',
    err_name: 'Bitte Namen angeben.', err_company: 'Bitte Firma angeben.',
    err_email: 'Bitte E-Mail angeben.', err_email_valid: 'Bitte gültige E-Mail angeben.',
    err_privacy: 'Bitte bestätigen.',
    btn_added: 'Hinzugefügt', btn_qty_raised: 'Menge erhöht',
    toast_added: '✓ „%title%“ zur Anfrage hinzugefügt · %count% %word%',
    toast_qty: '✓ Menge erhöht (×%n%) — „%title%“',
    announce_added: '„%title%“ zur Anfrage hinzugefügt, %count% %word%.',
    announce_qty: 'Menge erhöht auf %n%: „%title%“.',
    announce_limit: 'Maximum erreicht (%max%) — bitte Anfrage senden oder uns direkt kontaktieren.',
    fallback_part: 'Teil'
  };
  function loadI18n() {
    var el = document.querySelector('script[data-rfq-i18n]');
    if (!el) return;
    try {
      var data = JSON.parse(el.textContent);
      Object.keys(data).forEach(function (k) { if (typeof data[k] === 'string') I18N[k] = data[k]; });
    } catch (e) {}
  }
  loadI18n();
  function tpl(text, vars) {
    return text.replace(/%(\w+)%/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? vars[k] : m;
    });
  }

  function teilLabel(n) { return n === 1 ? I18N.part_one : I18N.part_other; }
  function clampMenge(m) { m = parseInt(m, 10); return (isNaN(m) || m < 1) ? 1 : m; }

  /* ---- Storage layer ---------------------------------------------------- */
  var storageOK = (function () {
    try { var k = '__rfq_t'; localStorage.setItem(k, '1'); localStorage.removeItem(k); return true; }
    catch (e) { return false; }
  })();

  function normalize(e) {
    return {
      handle: String((e && e.handle) || ''),
      titel: String((e && e.titel) || ''),
      teilenummer: String((e && e.teilenummer) || ''),
      url: String((e && e.url) || ''),
      menge: clampMenge(e && e.menge)
    };
  }

  /* Einmalige Migration v1 -> v2 (jedem Alt-Eintrag menge:1). Robust gegen kaputte Daten. */
  (function migrate() {
    if (!storageOK) return;
    try {
      if (localStorage.getItem(KEY) !== null) return;       // v2 vorhanden -> nichts tun
      var oldRaw = localStorage.getItem(OLD_KEY);
      if (oldRaw === null) return;                           // nichts zu migrieren
      var oldArr = JSON.parse(oldRaw);
      var migrated = Array.isArray(oldArr)
        ? oldArr.map(normalize).filter(function (e) { return e.handle; })
        : [];
      localStorage.setItem(KEY, JSON.stringify(migrated));
      localStorage.removeItem(OLD_KEY);
    } catch (e) {
      try { localStorage.removeItem(OLD_KEY); } catch (e2) {} // kaputte Altdaten -> verwerfen, v2 leer
    }
  })();

  function read() {
    if (!storageOK) return [];
    try {
      var arr = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(arr)) return [];
      return arr.map(normalize).filter(function (e) { return e.handle; });
    } catch (e) { return []; }
  }
  function write(arr) {
    if (!storageOK) return;
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function emit(detail) {
    document.dispatchEvent(new CustomEvent('rfq:change', { detail: detail || {} }));
  }

  var RFQ = {
    list: function () { return read(); },
    count: function () { return read().length; },
    has: function (handle) { return read().some(function (e) { return e.handle === handle; }); },
    add: function (entry) {
      if (!entry || !entry.handle) return { ok: false, reason: 'invalid' };
      var arr = read();
      var dup = arr.filter(function (e) { return e.handle === entry.handle; })[0];
      if (dup) {
        // Duplikat: Menge der bestehenden Position +1 (keine Dublette; Badge zählt weiterhin Positionen)
        dup.menge = clampMenge(dup.menge + 1);
        write(arr);
        emit({ type: 'menge', handle: dup.handle, menge: dup.menge });
        return { ok: true, reason: 'increment', menge: dup.menge };
      }
      if (arr.length >= MAX) { emit({ type: 'limit' }); return { ok: false, reason: 'limit' }; }
      arr.push(normalize({
        handle: entry.handle, titel: entry.titel, teilenummer: entry.teilenummer, url: entry.url, menge: 1
      }));
      write(arr);
      emit({ type: 'add', entry: entry });
      return { ok: true };
    },
    setMenge: function (handle, menge) {
      var m = clampMenge(menge);
      var arr = read(), found = false;
      arr.forEach(function (e) { if (e.handle === handle) { e.menge = m; found = true; } });
      if (!found) return { ok: false };
      write(arr);
      emit({ type: 'menge', handle: handle, menge: m });
      return { ok: true, menge: m };
    },
    getMenge: function (handle) {
      var e = read().filter(function (x) { return x.handle === handle; })[0];
      return e ? e.menge : 1;
    },
    remove: function (handle) {
      write(read().filter(function (e) { return e.handle !== handle; }));
      emit({ type: 'remove', handle: handle });
      return { ok: true };
    },
    clear: function () { write([]); emit({ type: 'clear' }); }
  };
  RFQ.storageOK = storageOK;
  RFQ.MAX = MAX;
  window.RFQ = RFQ;

  /* ---- Submission adapter (transport-neutral payload) ------------------- */
  function formspreeAdapter(payload) {
    var lines = payload.items.map(function (it, i) {
      return 'Teil ' + (i + 1) + '\n'
        + '- ' + it.titel + '\n'
        + '- Teile-Nr.: ' + (it.teilenummer || '—') + '\n'
        + '- Menge: ' + (it.menge || 1) + '\n'
        + '- Link: ' + location.origin + it.url;
    }).join('\n\n');
    var body = {
      name: payload.contact.name,
      company: payload.contact.company,
      email: payload.contact.email,
      phone: payload.contact.phone,
      message: payload.contact.message,
      'Angefragte Teile': lines,
      'Gesamtmenge': payload.items.reduce(function (s, it) { return s + (it.menge || 1); }, 0),
      _subject: 'Sammelanfrage: ' + payload.items.length + ' ' + teilLabel(payload.items.length),
      _replyto: payload.contact.email,
      _gotcha: payload.contact._gotcha || ''
    };
    return fetch(FORMSPREE_RFQ_ENDPOINT, {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) { return { ok: res.ok, status: res.status }; });
  }
  function submitInquiry(payload) { return formspreeAdapter(payload); }
  window.submitInquiry = submitInquiry;

  /* ---- UI controller ---------------------------------------------------- */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    loadI18n(); // erneut: Snippet-JSON ist jetzt sicher im DOM
    var fab = document.getElementById('rfqFab');
    var badge = document.getElementById('rfqFabBadge');
    var drawer = document.querySelector('rfq-drawer');
    if (!drawer) return; // Markup nicht vorhanden -> native Links bleiben (Fallback)

    var panel = drawer.querySelector('.rfq-panel');
    var listEl = drawer.querySelector('[data-rfq-list]');
    var emptyEl = drawer.querySelector('[data-rfq-empty]');
    var formWrap = drawer.querySelector('[data-rfq-formwrap]');
    var form = drawer.querySelector('[data-rfq-form]');
    var successEl = drawer.querySelector('[data-rfq-success]');
    var statusEl = drawer.querySelector('[data-rfq-status]');
    var countEls = drawer.querySelectorAll('[data-rfq-count]');
    var submitCountEls = drawer.querySelectorAll('[data-rfq-submit-count]');
    var submitWordEls = drawer.querySelectorAll('[data-rfq-teil-word]');
    var submitBtn = drawer.querySelector('[data-rfq-submit]');
    var live = document.getElementById('rfqLive');
    var toastEl = document.getElementById('rfqToast');
    var lastFocus = null;
    var receiveTimer = null;
    var shakeTimer = null;
    var isSubmitting = false;
    var toastTimer = null;
    var toastLeaveTimer = null;
    var enterTimer = null;

    /* --- rendering (single source of truth) --- */
    function setText(nodes, txt) { Array.prototype.forEach.call(nodes, function (n) { n.textContent = txt; }); }

    function renderList() {
      var items = RFQ.list();
      listEl.textContent = '';
      items.forEach(function (it) {
        var li = document.createElement('li');
        li.className = 'rfq-list__item';
        li.setAttribute('data-handle', it.handle);

        var info = document.createElement('div');
        info.className = 'rfq-list__info';

        var a = document.createElement('a');
        a.className = 'rfq-list__title';
        a.href = it.url || '#';
        a.textContent = it.titel || it.handle;

        var teil = document.createElement('span');
        teil.className = 'rfq-list__teil';
        teil.textContent = I18N.part_no + ' ' + (it.teilenummer || '—');

        info.appendChild(a);
        info.appendChild(teil);
        info.appendChild(buildStepper(it));

        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'rfq-list__remove';
        rm.setAttribute('data-rfq-remove', it.handle);
        rm.setAttribute('aria-label', I18N.remove_part + ': ' + (it.titel || it.handle));
        rm.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

        li.appendChild(info);
        li.appendChild(rm);
        listEl.appendChild(li);
      });
    }

    function buildStepper(it) {
      var wrap = document.createElement('div');
      wrap.className = 'rfq-qty';

      var dec = document.createElement('button');
      dec.type = 'button'; dec.className = 'rfq-qty__btn';
      dec.setAttribute('data-rfq-dec', ''); dec.setAttribute('aria-label', I18N.qty_decrease);
      dec.textContent = '−'; // minus
      dec.disabled = it.menge <= 1;

      var inp = document.createElement('input');
      inp.className = 'rfq-qty__input'; inp.type = 'text'; inp.inputMode = 'numeric';
      inp.setAttribute('data-rfq-qty', ''); inp.setAttribute('aria-label', I18N.qty);
      inp.value = it.menge;

      var inc = document.createElement('button');
      inc.type = 'button'; inc.className = 'rfq-qty__btn';
      inc.setAttribute('data-rfq-inc', ''); inc.setAttribute('aria-label', I18N.qty_increase);
      inc.textContent = '+';

      wrap.appendChild(dec); wrap.appendChild(inp); wrap.appendChild(inc);
      return wrap;
    }

    function syncQty(handle) {
      var li = listEl.querySelector('[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]');
      if (!li) return;
      var m = RFQ.getMenge(handle);
      var inp = li.querySelector('[data-rfq-qty]');
      var dec = li.querySelector('[data-rfq-dec]');
      if (inp) inp.value = m;
      if (dec) dec.disabled = m <= 1;
    }

    function render() {
      var n = RFQ.count();
      if (badge) badge.textContent = n;
      var wasActive = document.body.classList.contains('rfq-active');
      document.body.classList.toggle('rfq-active', n > 0);
      if (fab && n > 0 && !wasActive) enterFab(); // einmalige Entrance NUR beim Übergang 0→1
      setText(countEls, '(' + n + ')');
      setText(submitCountEls, n);
      setText(submitWordEls, teilLabel(n));
      renderList();

      var empty = n === 0;
      if (emptyEl) emptyEl.hidden = !empty;
      if (formWrap) formWrap.hidden = empty;
      if (submitBtn) submitBtn.disabled = empty;
    }

    /* --- A11y announce + FAB-Feedback --- */
    function announce(msg) { if (live) live.textContent = msg; }
    function enterFab() {
      if (!fab) return;
      fab.classList.remove('rfq-fab--enter');
      void fab.offsetWidth;
      fab.classList.add('rfq-fab--enter');
      clearTimeout(enterTimer);
      enterTimer = setTimeout(function () { fab.classList.remove('rfq-fab--enter'); }, 500);
    }
    function receiveFab() {
      // Empfangs-Puls, wenn der Toast am FAB "ankommt" (1 → 1.15 → 1)
      if (!fab) return;
      fab.classList.remove('rfq-fab--receive');
      void fab.offsetWidth; // reflow -> Animation feuert bei jedem Mal erneut
      fab.classList.add('rfq-fab--receive');
      clearTimeout(receiveTimer);
      receiveTimer = setTimeout(function () { fab.classList.remove('rfq-fab--receive'); }, 350);
    }
    function showToast(text) {
      // Ablauf: einblenden -> ~1.7s voll sichtbar -> 400ms Abflug zum FAB (CSS .is-leaving) -> FAB-Puls
      if (!toastEl) return;
      clearTimeout(toastTimer);
      clearTimeout(toastLeaveTimer);
      toastEl.classList.remove('is-leaving');
      toastEl.textContent = text;
      void toastEl.offsetWidth; // reflow: sauberer Neustart, falls ein Add mitten im Abflug kommt
      toastEl.classList.add('is-visible');
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('is-visible');
        toastEl.classList.add('is-leaving');
        toastLeaveTimer = setTimeout(function () {
          toastEl.classList.remove('is-leaving');
          receiveFab();
        }, 400);
      }, 1700);
    }
    function shakeFab() {
      if (!fab) return;
      fab.classList.remove('rfq-fab--shake');
      void fab.offsetWidth;
      fab.classList.add('rfq-fab--shake');
      clearTimeout(shakeTimer);
      shakeTimer = setTimeout(function () { fab.classList.remove('rfq-fab--shake'); }, 400);
    }

    /* --- drawer open/close (+ cart-drawer coordination) --- */
    function getFocusable() {
      return panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    }
    function openDrawer() {
      // Cart-Drawer schließen, falls offen (entkoppelt, nie beide offen)
      var cd = document.querySelector('cart-drawer');
      if (cd && cd.classList.contains('active') && typeof cd.close === 'function') { try { cd.close(); } catch (e) {} }

      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      resetStates();
      if (submitBtn) submitBtn.disabled = RFQ.count() === 0; // disabled beim Öffnen frisch aus dem Korb ableiten
      var f = getFocusable();
      if (f.length) f[0].focus();
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      else if (fab) fab.focus();
    }
    function isOpen() { return drawer.classList.contains('is-open'); }

    function resetStates() {
      if (successEl) successEl.hidden = true;
      if (formWrap) formWrap.hidden = RFQ.count() === 0;
      if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }
    }

    /* --- validation --- */
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function fieldErr(name, msg) {
      var span = drawer.querySelector('[data-rfq-error="' + name + '"]');
      var input = drawer.querySelector('[name="' + name + '"]');
      if (span) { span.textContent = msg || ''; span.hidden = !msg; }
      if (input) input.classList.toggle('rfq-invalid', !!msg);
      return input;
    }
    function clearErr(name) { fieldErr(name, ''); }

    function validate() {
      var ok = true, firstBad = null;
      var get = function (n) { var el = form.elements[n]; return el ? el.value.trim() : ''; };
      function fail(name, msg) { var input = fieldErr(name, msg); ok = false; if (!firstBad) firstBad = input; }

      if (!get('name')) fail('name', I18N.err_name); else clearErr('name');
      if (!get('company')) fail('company', I18N.err_company); else clearErr('company');
      var email = get('email');
      if (!email) fail('email', I18N.err_email);
      else if (!EMAIL_RE.test(email)) fail('email', I18N.err_email_valid);
      else clearErr('email');
      var priv = form.elements['privacy'];
      if (priv && !priv.checked) fail('privacy', I18N.err_privacy); else clearErr('privacy');

      if (!ok && firstBad && firstBad.focus) firstBad.focus();
      return ok;
    }

    /* --- submit --- */
    function buildPayload() {
      var get = function (n) { var el = form.elements[n]; return el ? el.value.trim() : ''; };
      var items = RFQ.list();
      var totalMenge = items.reduce(function (s, e) { return s + (e.menge || 1); }, 0);
      return {
        contact: {
          name: get('name'), company: get('company'), email: get('email'),
          phone: get('phone'), message: get('message'), privacyAccepted: true,
          _gotcha: (form.elements['_gotcha'] && form.elements['_gotcha'].value) || ''
        },
        items: items,
        meta: { source: 'rfq-basket', submittedAt: new Date().toISOString(), itemCount: items.length, totalMenge: totalMenge, pageUrl: location.href }
      };
    }
    function onSubmit(e) {
      e.preventDefault();
      if (isSubmitting) return;
      if (RFQ.count() === 0) return;
      if (statusEl) { statusEl.hidden = true; statusEl.textContent = ''; }
      var payload = buildPayload();
      if (payload.contact._gotcha) { // Bot -> still "ok" ohne Versand
        RFQ.clear(); showSuccess(); return;
      }
      if (!validate()) return;

      isSubmitting = true;
      submitBtn.disabled = true; // visuelles Feedback während des Sendens
      // Original-Label (inkl. der dynamischen Count-Spans) als echte Knoten sichern – nicht hardcoden.
      var origNodes = Array.prototype.slice.call(submitBtn.childNodes);
      submitBtn.textContent = I18N.sending;
      submitInquiry(payload).then(function (res) {
        if (res && res.ok) { RFQ.clear(); showSuccess(); }
        else { showError(); }
      }).catch(function () {
        showError();
      }).finally(function () {
        // Drei Dinge: Flag lösen, Label wiederherstellen, disabled count-getrieben neu setzen
        // (verhindert Hängenbleiben im Fehlerfall, da danach kein render() läuft).
        isSubmitting = false;
        submitBtn.textContent = '';
        origNodes.forEach(function (n) { submitBtn.appendChild(n); });
        submitBtn.disabled = RFQ.count() === 0;
      });
    }
    function showSuccess() {
      if (formWrap) formWrap.hidden = true;
      if (listEl) listEl.hidden = true;
      if (emptyEl) emptyEl.hidden = true;
      if (successEl) successEl.hidden = false;
    }
    function showError() {
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = I18N.send_error;
      }
    }

    /* --- bind add-buttons (event delegation; progressive enhancement) --- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rfq-add]');
      if (!btn) return;
      e.preventDefault();
      var res = RFQ.add({
        handle: btn.getAttribute('data-handle'),
        titel: btn.getAttribute('data-titel'),
        teilenummer: btn.getAttribute('data-teil'),
        url: btn.getAttribute('data-url')
      });
      var titel = btn.getAttribute('data-titel') || I18N.fallback_part;
      if (res.ok) {
        var orig = btn.getAttribute('data-rfq-orig');
        if (orig === null) btn.setAttribute('data-rfq-orig', btn.innerHTML);
        btn.classList.add('rfq-add--added');
        btn.innerHTML = res.reason === 'increment'
          ? '<span aria-hidden="true">✓</span> ' + I18N.btn_qty_raised
          : '<span aria-hidden="true">✓</span> ' + I18N.btn_added;
        setTimeout(function () {
          var o = btn.getAttribute('data-rfq-orig');
          if (o !== null) btn.innerHTML = o;
          btn.classList.remove('rfq-add--added');
        }, 1600);
        if (res.reason === 'increment') {
          // Duplikat: Menge +1 statt Dublette; Badge (Positionszahl) bleibt bewusst unverändert
          showToast(tpl(I18N.toast_qty, { n: res.menge, title: titel }));
          announce(tpl(I18N.announce_qty, { n: res.menge, title: titel }));
        } else {
          showToast(tpl(I18N.toast_added, { title: titel, count: RFQ.count(), word: teilLabel(RFQ.count()) }));
          announce(tpl(I18N.announce_added, { title: titel, count: RFQ.count(), word: teilLabel(RFQ.count()) }));
        }
      } else if (res.reason === 'limit') {
        shakeFab();
        announce(tpl(I18N.announce_limit, { max: RFQ.MAX }));
      }
    });

    /* --- remove + Mengen-Stepper (delegation in list) --- */
    function liHandle(node) { var li = node.closest('[data-handle]'); return li ? li.getAttribute('data-handle') : null; }
    listEl.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rfq-remove]');
      if (rm) { RFQ.remove(rm.getAttribute('data-rfq-remove')); return; }
      var dec = e.target.closest('[data-rfq-dec]');
      if (dec) { var h = liHandle(dec); if (h) RFQ.setMenge(h, RFQ.getMenge(h) - 1); return; }
      var inc = e.target.closest('[data-rfq-inc]');
      if (inc) { var h2 = liHandle(inc); if (h2) RFQ.setMenge(h2, RFQ.getMenge(h2) + 1); return; }
    });
    listEl.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-rfq-qty]');
      if (!inp) return;
      var h = liHandle(inp);
      if (h) RFQ.setMenge(h, inp.value); // setMenge clampt; syncQty schreibt geclampten Wert zurück
    });

    /* --- open/close wiring --- */
    if (fab) fab.addEventListener('click', openDrawer);
    Array.prototype.forEach.call(drawer.querySelectorAll('[data-rfq-close]'), function (b) {
      b.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { closeDrawer(); return; }
      if (e.key === 'Tab' && isOpen()) {
        var f = getFocusable(); if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    if (form) {
      form.addEventListener('submit', onSubmit);
      ['name', 'company', 'email'].forEach(function (n) {
        var el = form.elements[n];
        if (el) el.addEventListener('input', function () { clearErr(n); });
      });
      var priv = form.elements['privacy'];
      if (priv) priv.addEventListener('change', function () { clearErr('privacy'); });
    }

    /* --- cart-drawer coordination: schließt RFQ, wenn Cart-Drawer öffnet --- */
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (cartDrawer.classList.contains('active') && isOpen()) closeDrawer();
      }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }

    /* --- react to all mutations + handle empty-while-open --- */
    document.addEventListener('rfq:change', function (ev) {
      var d = ev.detail || {};
      if (d.type === 'menge') { syncQty(d.handle); return; } // nur Stepper updaten, kein Listen-Rebuild
      var wasSuccess = successEl && !successEl.hidden;
      render();
      // Beim Entfernen des letzten Teils bei offenem Drawer: Empty-State zeigen, nicht schließen
      if (isOpen() && RFQ.count() === 0 && !wasSuccess) {
        if (formWrap) formWrap.hidden = true;
        if (listEl) listEl.hidden = false;
      } else if (RFQ.count() > 0 && listEl) {
        listEl.hidden = false;
      }
    });

    render(); // initial
  });
})();
